import { Autocomplete, Box, MenuItem, TextField } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { getAllAvailableCourse, getCroList } from '../../../../../redux/features/crmSlice';
import { getSubjects } from '../../../../../redux/features/croSlice';
import { getCROlistUnderProject } from '../../../../../redux/features/CRDslice';
import { FOUNDATION_DEPARTMENT_ID } from '../../../../../utils/constants/departmentDetails';
import GlobalSelectFieldWithoutFormik from '../../../../../components/mui/GlobalSelectFieldWithoutFormik';
import { PercentageDropDown } from '../../../../../utils/impactReport/PercentageDropDown';
import { crmTypes, croTypeNames } from '../../../../../utils/employeeTypes';
import { isSameUserType } from '../../../../../utils/helperFunction';
import { ALL_EXAM_DROP_JSON } from '../utils/constaint';

export default function Filters({ allFilter, setAllFilter, percentageFilter }) {
  const { croList, loading, allAvailableCourse } = useSelector((state) => state.crm);
  const { loading: subjectLoading, subjects } = useSelector((state) => state.cro);
  const { crosunderproject } = useSelector((state) => state.crd);
  const dispatch = useDispatch();
  const profile = JSON.parse(localStorage.getItem('cred')).profile;
  const [flag, isCro] = useMemo(
    () => [
      isSameUserType({ roleArray: crmTypes, role: profile?.role }),
      isSameUserType({ roleArray: croTypeNames, role: profile?.role }),
    ],
    [profile],
  );

  useEffect(() => {
    dispatch(flag ? getCroList({ search: '' }) : getCROlistUnderProject(FOUNDATION_DEPARTMENT_ID));
    dispatch(getAllAvailableCourse());
    dispatch(getSubjects());
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        mb: 3,
        flexDirection: { xs: 'column', md: 'row' },
        width: { sm: '100%', md: 840 },
      }}
    >
      <Box display={'flex'} gap={1} width={'100%'} justifyContent={'space-between'}>
        <Autocomplete
          options={allAvailableCourse}
          getOptionKey={(e) => e.course_available_id}
          getOptionLabel={(e) => e.course_name}
          onChange={(e, v) =>
            setAllFilter((prev) => {
              return { ...prev, course_id: v?.course_available_id ?? '' };
            })
          }
          loading={loading}
          // sx={{ minWidth: { xs: '100%', md: 130 } }}
          sx={{ width: '100%' }}
          renderInput={(params) => <TextField {...params} label="Course" />}
        />
        <Autocomplete
          options={subjects}
          getOptionKey={(e) => e.subjectId}
          getOptionLabel={(e) => e.subjectName}
          loading={subjectLoading}
          onChange={(e, v) =>
            setAllFilter((prev) => {
              return { ...prev, subject_id: v?.subjectId ?? '' };
            })
          }
          sx={{ width: '100%' }}
          // sx={{ width: { xs: '100%', md: 130 } }}
          renderInput={(params) => <TextField {...params} label="Subject" />}
        />
      </Box>
      <Box display={'flex'} gap={1} width={'100%'}>
        {(Boolean(croList?.length) || !flag) && (
          <Autocomplete
            options={flag ? croList : crosunderproject}
            getOptionKey={(e) => e.userID}
            getOptionLabel={(e) => e.name}
            loading={loading}
            disabled={isCro}
            onChange={(e, v) =>
              setAllFilter((prev) => {
                return { ...prev, cro_id: v?.userID ?? '' };
              })
            }
            sx={{ width: '100%' }}
            // sx={{ width: { xs: '100%', md: 200 } }}
            renderInput={(params) => <TextField {...params} label="CRO Name" />}
          />
        )}
        {percentageFilter && (
          <>
            <GlobalSelectFieldWithoutFormik
              sx={{ width: '100%' }}
              data={ALL_EXAM_DROP_JSON}
              label={'Exam Type'}
              keys={{ itemId: 'id', itemValue: 'value' }}
              selectedDetails={allFilter?.examType}
              setChange={(fn) => {
                if (typeof fn === 'function') {
                  const newExamType = fn(allFilter?.examType);
                  setAllFilter((prev) => ({ ...prev, examType: newExamType }));
                }
              }}
            />
            <GlobalSelectFieldWithoutFormik
              sx={{ width: '100%' }}
              data={PercentageDropDown}
              label={'Percentage'}
              keys={{ itemId: 'id', itemValue: 'label' }}
              selectedDetails={allFilter?.percentage}
              disabled={allFilter?.examType?.id === 0}
              setChange={(fn) => {
                if (typeof fn === 'function') {
                  const newPercentage = fn(allFilter?.percentage);
                  setAllFilter((prev) => ({ ...prev, percentage: newPercentage }));
                }
              }}
            />
          </>
        )}
      </Box>
    </Box>
  );
}
